import { redirect } from "react-router-dom";

export const indexRedirect = () => {
  return redirect("/", { status: 301 });
};
